import { useEffect, useState } from "react";

type AsyncState<T> = {
  state: T;
  loading: boolean;
  error: any;
};

export function useAsyncState<T>(
  asyncSupplier: () => Promise<T> | null | undefined,
  initialState: T,
  dependencies: any[],
): AsyncState<T> {
  const [state, setState] = useState<T>(initialState);
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;
    if (typeof asyncSupplier === "function") {
      setLoading(true);
      setError(null);
      // @ts-ignore TS2533: Object is possibly 'null' or 'undefined'.
      asyncSupplier()
        .then((response: T) => {
          // make sure the component hasn't unmounted while the asyncSupplier was waiting to be resolved
          if (isMounted) {
            setState(response);
          }
        })
        .catch((e) => {
          if (isMounted) {
            console.error(e);
            setError(e);
          }
        })
        .finally(() => {
          if (isMounted) {
            setLoading(false);
          }
        });
    }

    return () => {
      isMounted = false;
    };
  }, dependencies);

  return { state, loading, error };
}
